import { Button } from "primereact/button";
import { Card } from "primereact/card";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import digio from "./digio"
import $ from "jquery";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Chip } from "@mui/material";
import verified from "../../assets/check-mark.png"
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { ThreeDots } from "react-loader-spinner";

const Esign = ({ msg }) => {
  const [isAuth, setAuth] = useState(sessionStorage.getItem("userCode"));
  const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);
    const [status, setStatus] = useState(null);
  const [sign, setSign] = useState({})
  const userCode = sessionStorage.getItem("userCode");
const [showMassage, setshowMassage] = useState(false)
const [showMassage1, setshowMassage1] = useState(false)
const [showMassage2, setshowMassage2] = useState(false)
const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const URL = process.env.REACT_APP_BASE_URL;

 

useEffect(() => {
  if( msg.esignDetailStatus === "PENDING") {
    setshowMassage(true)
  } else{
    setshowMassage(false)
  }
}, [msg])


  const handleClick = async () => {
    setLoading(true) 
    setshowMassage1(false)
      try {
        const response = await axios.post(`${URL}/Esign/requestEsign`, {
          userCode: userCode, latitude: lat.toString(), longitude: lng.toString()
        }, { withCredentials: true });
    setLoading(false)
        setSign(response.data.data);
        if(response.data.result.flag == 1){
          IntializeDigigo(
            "production",
            response.data.data.access_token_id,
            response.data.data.signing_parties_identifier,
            response.data.data.userID,
            "flag",
            {
              userCode: userCode
            }
           
          )
        }
        
      } catch (error) {
        console.log("error in get data", error);
        setLoading(false)
      }
    
  };

  const getLocation = () => {
    if (!navigator.geolocation) {
  setStatus('Geolocation is not supported by your browser');
} else {
        setStatus('Locating...');
        navigator.geolocation.getCurrentPosition((position) => {
            setStatus(null);
            setLat(position.coords.latitude);
            setLng(position.coords.longitude);
            // alert('Location captured successfully')
            if(msg.personalDetailStatus == 'IN-PROCESS' && msg.segmentDetailStatus == null) {
              setshowMassage1(true)
      setLoading(false)
      return
    }
            handleClick()
        }, () => {
            setshowMassage2(true)
        });
    }
}
 

  function IntializeDigigo(
    options,
    access_token_id, signing_parties_identifier, userID,
    flag,
    myValues
  
  ) {
    var digio = new Digio(options);
    digio.init(myValues);
    
   digio.submit(userID, signing_parties_identifier, access_token_id, myValues);
  }

  useEffect(() => {
    if (isAuth) {
      navigate("/esign");
    } else {
      navigate("/");
    }
  }, []);

  const onHide = () => {
    setshowMassage(false)
    setshowMassage1(false)
    setshowMassage2(false)
  };

  const onUploadChange = () => {
    setshowMassage1(false)
    navigate('/segment')
  };

  const dialogFooter = (
    <div className="flex justify-content-center">
      <Button
        label="OK"
        className="p-button-raised p-button-sm smc_color"
        autoFocus
        onClick={onHide}
      />
    </div>
  );

  const dialogFooter2 = (
    <div className="flex justify-content-center">
      <Button
        label="Close"
        className="p-button-raised p-button-sm smc_color"
        autoFocus
        onClick={onHide}
      />
    </div>
  );

  const dialogFooter1 = (
    <div className="flex justify-content-center">
      <Button
        label="Upload Income Proof"
        className="p-button-raised p-button-sm smc_color"
        onClick={onUploadChange}
      />
      <Button
        label="Proceed"
        className="p-button-raised p-button-sm smc_color"
        onClick={handleClick}
      />
    </div>
  );

  return (
    <>
    <Dialog
        visible={showMassage}
        position="top"
        footer={dialogFooter}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <i
            className="pi pi-check-circle"
            style={{ fontSize: "3rem", color: "var(--green-500)" }}
          ></i>
          <h5 className="c_pop">Your request for Re-activation is under process and It will be updated within 2 working days after successful acceptance of request.</h5>
        </div>
      </Dialog>
      <Dialog
        visible={showMassage1}
        position="center"
        footer={dialogFooter1}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <i
            className="pi pi-exclamation-circle"
            style={{ fontSize: "3rem", color: "var(--red-500)" }}
          ></i>
          <h5 className="c_pop">Warning</h5>
          <p>You have not uploaded any income proof. <br />
If you have a derivatives account, please note that it is mandatory to upload income proof.</p>
        </div>
      </Dialog>
      <Dialog
        visible={showMassage2}
        position="center"
        footer={dialogFooter2}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <i
            className="pi pi-exclamation-circle"
            style={{ fontSize: "3rem", color: "var(--red-500)" }}
          ></i>
          <h5 className="c_pop">Allow Location Access</h5>
<p>To continue with E-sign, we need your location to verify your identity. This information will be used only for the purpose of E-sign and will not be shared with any third-party</p>
<p><a href="https://support.google.com/chrome/answer/142065?hl=en" target='_blank'>click here</a> to Allow your location </p>
        </div>
      </Dialog>
       <Card
        style={{
          margin: "0.5em 2em 2em 2em",
          padding: "1em",
          borderRadius: 20,
        }}
      >
        <div className="line">
          <h2>
            Esign
          </h2>
          <div>
              {msg.esignDetailStatus == "VERIFIED" ? <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<img src={verified} alt='verify' width='25px' />} label={msg.esignDetailStatus}  variant="outlined" sx={{background: '#0080004f'}} />
              
              </div>: msg.esignDetailStatus == "PENDING" ? <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<HourglassTopIcon />} label={msg.esignDetailStatus}  variant="outlined" sx={{background: '#d3d3436b'}} />
              
              
            
            </div> : msg.esignDetailStatus == "REJECTED" ? <div
            style={{
              fontSize: 12,
              color:'red',
              float: "right",
              marginTop: 20,
              display:'contents'
            }}
          >{msg.esignDetailRemarks}</div> : null}
            </div>
          <hr />
        </div>
        <div className="other_details_esign">
          {/* <ul class="unstyled centered">
            <li>
              <input
                className="styled-checkbox"
                id="styled-checkbox-1"
                type="checkbox"
                value="value1"
                checked
                style={{ width: "15px", height: "15px" }}
                disabled={msg.esignDetailStatus == "VERIFIED"}
              />
              <label for="styled-checkbox-1" style={{fontSize: '1rem'}}>I accept the terms & conditions</label>
            </li>
          </ul> */}
          <div className="btn_sign">
            <Button
            disabled={loading || msg.personalDetailStatus == null || msg.personalDetailStatus == "" || msg.personalDetailStatus == "REJECTED" || msg.personalDetailStatus == "PENDING" || msg.addressDetailStatus == null || msg.addressDetailStatus == "" || msg.addressDetailStatus == "REJECTED" || msg.addressDetailStatus == "PENDING" || msg.esignDetailStatus == "PENDING" || msg.esignDetailStatus == "VERIFIED" || msg.segmentDetailStatus == "REJECTED" }
              label={loading ? <ThreeDots
                height="20"
                width="80"
                radius="9"
                color="#ffffff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ display: 'flex', justifyContent: 'center', position: 'relative' }}
                wrapperClassName=""
                visible={true}
              /> :"Proceed with Esign"}
              style={{ width: "235px", marginTop: "1%" }}
              className="p-button-raised mr-3 p-button-sm smc_color"

              onClick={getLocation} 
            />
      
          </div>
        </div>
      </Card> 
    </>
  );
};

export default Esign;
